<template>
  <div class="moti" id="Monetize">
    <p class="title" name="Monetize">Monetize</p>
    <div class="main">
      <el-row :gutter="30">
        <el-col :sm="12" :xs="24" >
          <div class="moti-text">
            <div class="moti-img">
              <img width="100%" src="@images/moti_1.png" />
            </div>
            <h4 class="sub-title">Increased Revenue from our diverse global demand</h4>
            <p class="descript">Boost your earnings with our powerful AI-powered monetization platform, and from our diverse advertisers & premium demand worldwide giving you higher CPMs and fill rate</p>
          </div>
        </el-col>
        <el-col :sm="12" :xs="24" >
          <div class="moti-text">
            <div class="moti-img">
              <img width="100%" src="@images/moti_2.png" />
            </div>
            <h4 class="sub-title">Improved Efficiency & Higher Yield</h4>
            <p class="descript">Our unified auction & Prebid solution ensure our developers are getting the higher yield for every impression</p>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :sm="12" :xs="24" >
          <div class="moti-text">
            <div class="moti-img">
              <img width="100%" src="@images/moti_3.png" />
            </div>
            <h4 class="sub-title">Clean & Safe Marketplace</h4>
            <p class="descript">All ads are scanned by our proprietary and MRC certified tools to remove any bad ads, such as malicious ads. Malware, etc</p>
          </div>
        </el-col>
        <el-col :sm="12" :xs="24" >
          <div class="moti-text">
            <div class="moti-img">
              <img width="100%" src="@images/moti_4.png" />
            </div>
            <h4 class="sub-title">Advanced Transparent Reporting</h4>
            <p class="descript">We provide advanced & transparent reporting enabling our developers to slice and dice their data for an in-depth analysis of their inventory performance to make informed decisions</p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "Monetize",
  data: function () {
    return {
    };
  }
};
</script>
<style lang="scss" scoped>
.moti {
  background: #ffffff;
  position: relative;
  box-shadow: $section-box-shadow;
  .main {
    max-width: px2rem(1000);
    margin: 0 auto;
    margin-top: px2rem(20);
    .el-row {
      margin: px2rem(0) px2rem(0);
      .el-col {
        margin: px2rem(40) auto;
        .moti-text{
          height: 100%;
          text-align: center;
          // width: 50%;
          max-width: px2rem(350);
          margin: 0 auto;
          .sub-title {
            margin: px2rem(20) 0 px2rem(15) 0;
          }
          .descript {
            font-size: px2rem(16);
            letter-spacing: 1px;
            line-height: 1.3em;
            margin: 0 auto;
            margin-top: px2rem(-5);
            color: #777;
          }
          .moti-img {
            width: 90%;
            height: px2rem(180);
            margin: 0 auto;
            overflow: hidden;
            border: 0px solid rgba(0, 0, 0, 0.2);
            border-radius: 8px;
            box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.1);
            padding: px2rem(10);
            box-sizing: border-box;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
      }
    }
    .moti-sp-title {
      font-size: px2rem(20);
      color: $--color-primary;
      text-align: center;
      margin: px2rem(80) px2rem(140);
      margin-top: px2rem(140);
    }
    .moti-sp {
      height: px2rem(120);
      .el-button {
        border-radius: px2rem(10);
        font-size: px2rem(16);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        padding: px2rem(15) px2rem(20);
        i {
          font-size: px2rem(17);
        }
      }
    }
  }
}
</style>